// Кап автоматической перезагрузки страницы (план IG-FIX, Ф8.0/Ф8.1).
//
// Страница чинит себя сама двумя способами: не догрузился кусок сборки (ChunkLoadError
// после выкатки) и разъехалась разметка при гидрации (React #418 и родня — 465 случаев
// за 18.08, у владельца при этом умирали кнопки). Оба лечатся одинаково — ОДНА
// перезагрузка, — и оба обязаны иметь один общий кап от петли: перезагрузка, которая
// снова падает тем же, не должна крутить страницу по кругу.
//
// INVARIANT(scriptera): метка последней автоперезагрузки — ОДНА на все причины
// (sessionStorage, ключ scr-chunk-reload). Причина: два независимых капа дают петлю
// «чанк → гидрация → чанк». Канон: docs/HOW-IT-WORKS.md §13.

/** Не чаще одной автоперезагрузки в 30 секунд — на все причины вместе. */
export const AUTO_RELOAD_GAP_MS = 30_000;

/** Ключ метки в sessionStorage (исторический, менять нельзя: у живых вкладок он уже стоит). */
export const AUTO_RELOAD_KEY = 'scr-chunk-reload';

/**
 * Можно ли перезагрузиться прямо сейчас: `raw` — что лежит в метке (строка из
 * sessionStorage, null, мусор), `now` — текущее время.
 */
export function mayAutoReload(raw: string | number | null | undefined, now: number, gapMs = AUTO_RELOAD_GAP_MS): boolean {
  const last = Number(raw ?? 0);
  // Пусто/мусор — перезагрузок ещё не было.
  if (!Number.isFinite(last) || last <= 0) return true;
  // Метка из будущего (часы устройства уехали назад) — не рискуем петлёй.
  if (last > now) return false;
  return now - last >= gapMs;
}
